export class BioRxivAPIModel {
  ArticledataAPI: any;
  ArticledetailsAPI: any;
  GetJournalList: string = "";
  BioDashboardSummaryAPI: string = "";
  GetVendorProcessArticleList: string = "";
  GetNTProcessArticleList: string = "";
  BenchMarkPages: string = "";
}
